import request from "@/utils/request";

export function getDocuments(params) {
  return request({
    url: `/documents/documents/`,
    method: `get`,
    params,
  });
}

export function getDocumentId(id, params) {
  return request({
    url: `/documents/documents/${id}/`,
    method: `get`,
    params,
  });
}

export function postDocuments(data) {
  data.pdf = data.pdf[0].response.path;
  data.regions = data.regions ? data.regions : [];
  return request({
    url: `/documents/documents/`,
    method: `post`,
    data,
  });
}

export function putDocuments(id, data) {
  data.pdf =
    typeof data.pdf === "object" ? data.pdf[0].response.path : data.pdf;

  data.regions = data.regions.map((el) => {
    return typeof el == "object" ? el.id : el;
  });
  return request({
    url: `/documents/documents/${id}/`,
    method: `put`,
    data,
  });
}

export function deleteDocuments(id) {
  return request({
    url: `/documents/documents/${id}/`,
    method: `delete`,
  });
}
